import { Icon, IconType } from "../../../common/icons/Icon";
import { useAiExampleQuestions } from "../hooks/useAiExampleQuestions";
import { aiAssistantTexts } from "../models/aiAssistantModels";
import styles from "./AiMessages.module.scss";

interface IAiEmptyStateProps {
  /** Puts the question into the message box; it is not sent. */
  onPickExample: (question: string) => void;
}

export const AiEmptyState = ({ onPickExample }: IAiEmptyStateProps) => {
  const exampleQuestions = useAiExampleQuestions();
  return (
    <div className={styles.empty}>
      <span className={styles.empty_icon} aria-hidden="true">
        <Icon type={IconType.Sparkle} width="26px" height="26px" color="currentColor" />
      </span>
      <h2 className={styles.empty_title}>{aiAssistantTexts.emptyTitle}</h2>
      <p className={styles.empty_intro}>{aiAssistantTexts.emptyIntro}</p>
      <div className={styles.empty_examples}>
        {exampleQuestions.map((question) => (
          <button key={question} type="button" className={styles.example_chip} onClick={() => onPickExample(question)}>
            {question}
          </button>
        ))}
      </div>
    </div>
  );
};
